export const urls = {
  home: '/',
  authentication: '/login',
  callback: '/callback',
  integrations: '/integrations',
  tenantManagement: '/tenant-management',
  settings: '/settings/:tab?',
  warehouseManagement: '/warehouse-management/:tab?',
  stockManagement: '/stock-management/:tab?',
  products: '/products/:tab?',
  productDetails: '/products/:id/:tab?',
  productDetailsForOtherRoutes: '/products/:productId/:tab?',
  operationManagement: '/operation-management/:tab?',
  orderManagement: '/order-management',
  orderDetails: '/order-details/:id/:tab?',
  orderDetailsForOtherRoutes: '/order-details/:salesOrderId/:tab?',
  returnManagement: '/return-management/:view?',
  returnDetails: '/return-details/:id',
  productReturnDetails: '/return-details/:returnPackageId',
  packingStation: '/packing-station',
  wallPackingStation: '/wall-packing-station',
  singleItemPackingStation: '/single-item-packing-station',
  singleItemFastPackingStation: '/single-item-fast-packing-station',
  returnStation: '/return-station',
  stationLogin: '/station-login',
  slamStation: '/slam-station',
  problemSolver: '/problem-solver',
  problemList: '/problem-solver/list/:id',
  problemDetails: '/problem-solver/details/:id',
  problemDetailsForOtherRoutes: '/problem-solver/details/:problemId',
  quarantineManagement: '/quarantine-management/:tab?',
  lostItems: '/lost-items',
  orderTrackingReport: '/order-tracking-report',
  receivingOperations: '/receiving/:view/:tab?',
  receivingPurchaseOrders: '/receiving-purchase-orders/:operationId/:operationName',
  receivingOrderDetails: '/receiving-order-details/:operationId/:operationName/:id/:referenceNumber/:source/:tab?',
  waybillsReceivingOrderDetails:
    '/receiving-order-details/:operationId/:operationName/:purchaseOrderId/:purchaseOrderReferenceNumber/:source/:tab?',
  receivingWaybillDetails:
    '/receiving-waybill-details/:operationId/:operationName/:orderId/:referenceNumber/:source/:id/:tab?',
  changeLog: '/change-log/:tab?',
  dispatchHistory: '/dispatch-history',
  dispatchDetails: '/dispatch-details/:id/:tab?',
  dispatchManagement: '/dispatch-management',
  pickingManagement: '/picking-management/:tab?',
  replenishmentManagement: '/replenishment-management',
  replenishmentNeeds: '/replenishment-needs',
  manualReplenishment: '/manual-replenishment',
  manualPicklists: '/manual-picklists',
  batchManagement: '/batch-management',
  batchDetails: '/batch-details/:referenceNumber/:name/:batchType/:tab?',
  batchDetailsPickListDetails: '/picklist-details/:id/:tab?',
  pickListDetails: '/picklist-details/:pickListId/:tab?',
  pickingProblems: '/picking-problems/:tab?',
  dispatchProblems: '/dispatch-problems',
  notFound: '*',
  zoneDetails: '/zone-details/:id/:tab?',
  zoneDetailsForOtherRoutes: '/zone-details/:zoneId/:tab?',
  inboundProblems: '/inbound-problems',
  inboundProblemSolver: '/inbound-problem-solver',
  inboundProblemList: '/inbound-problem-solver/list/:sourceType/:id',
  inboundProblemDetails: '/inbound-problem-solver/details/:sourceType/:id',
  masterCartonDetails: '/master-carton/:id',
  flowManagement: '/flow-management/:tab?',
  putAwayManagement: '/putaway-management/:tab?',
  missingItemTransferStation: '/missing-item-transfer-station',
  otherCountings: '/otherCountings/:tab?',
  createW2WPlan: '/create-w2w-plan/:id',
  trackW2WPlan: '/track-w2w-plan/:id/:tab',
  w2wPlanReports: '/w2w-plan-reports/:id/:tab',
  countingPlanDetails: '/counting-plan-details/:referenceNumber/:id',
  activeCountingPlanDetails: '/counting-plan-details/:stockCountingPlanReferenceNumber/:stockCountingPlanId',
  createCountingPlan: '/create-counting-plan',
  inventoryView: '/inventory-view/:tab?',
  inventoryTrolleyDetails: '/inventory-trolley-details/:label',
  inventoryTrolleyDetailsWithTrolleyLabel: '/inventory-trolley-details/:trolleyLabel',
  stocksTrolleyDetails: '/inventory-trolley-details/:addressLabel',
  inventoryToteDetails: '/inventory-tote-details/:toteLabel',
  stocksToteDetails: '/inventory-tote-details/:containerLabel',
  inventoryCellDetails: '/inventory-cell-details/:cellLabel/:tab',
  inventoryCellDetailsWithLabel: '/inventory-cell-details/:label/:tab',
  inventoryDetailsContainerLabelToCellDetails: '/inventory-cell-details/:containerLabel/:tab',
  inventoryDetailsContainerLabelToToteDetails: '/inventory-tote-details/:containerLabel',
  stocksCellDetails: '/inventory-cell-details/:containerLabel/:tab',
  inventoryTrolleyDetailtoToteDetails: '/inventory-tote-details/:label',
  countingListDetails: '/counting-list-details/:id/:referenceNumber',
  systemCountingListDetails: '/counting-list-details/:stockCountingListId/:stockCountingListReferenceNumber',
  inboundItemStation: '/inbound-item-station',
  stockCountingPlanDetails: '/counting-plan-details/:stockCountingPlanReferenceNumber',
  dispatchPackages: '/dispatch-packages',
  productFeedManagement: '/product-feed-management/:tab?',
  expirationDateTrack: '/expiration-date-track',
  hovPackingStation: '/hov-packing-station',
  serialNumberTrack: '/serial-number-track/:tab?',
  rebinStation: '/rebin-station',
  hovRebinStation: '/hov-rebin-station',
  simplePackingStation: '/simple-packing-station',
  rasPickingStation: '/ras-picking-station',
  rasOrderBasedPickingStation: '/ras-order-based-picking-station',
  rasPutAwayStation: '/ras-putaway-station',
  rasProblemSolverStation: '/ras-problem-solver-station/:tab?',
  syncComparison: '/sync-comparison/:tab',
  orderPickListProblems: '/order-pick-list-problems/:tab?',
  approvedOrderSlamStation: '/approved-order-slam-station',
  missingOrderList: '/missing-order-list',
  missingNotifications: '/missing-notifications',
  wallInventoryView: '/wall-inventory-view',
  waybillStation: '/waybill-station',
};

export const createUrl = (template: string, params: Record<string, string | number | undefined>): string => {
  let url = template;

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      url = url.replace(`:${key}`, String(value));
    }
  });

  // Remove optional parameters that weren't provided (marked with ?)
  url = url.replace(/\/:[^/?]+\?/g, '');

  return url;
};
